// batches
export type BatchStatus = typeof BATCH_STATUS_VALID | typeof BATCH_STATUS_WARNING | typeof BATCH_STATUS_INVALID;

export const BATCH_STATUS_VALID = 1;
export const BATCH_STATUS_WARNING = 2;
export const BATCH_STATUS_INVALID = 3;
